module.exports = __webpack_public_path__ + "static/img/5.c48c538.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/5.png
// module id = zKI3
// module chunks = 0